/**
 * Speurtocht Module
 * Treasure hunt game for family weekends
 */

// Types
export * from "./types";

// Hooks
export { useSpeurtocht } from "./hooks/useSpeurtocht";
export { useSpeurtochts } from "./hooks/useSpeurtochts";
export { useActiveSpeurtocht } from "./hooks/useActiveSpeurtocht";
export { 
  useLocationCheck, 
  formatDistance, 
  getDirectionEmoji 
} from "./hooks/useLocationCheck";
export { useSpeurttochtAdmin } from "./hooks/useSpeurttochtAdmin";

// Components
export { ActiveSpeurttochtCard } from "./components/ActiveSpeurttochtCard";
export { QRCodeScanner } from "./components/QRCodeScanner";

// Utilities
export {
  notifySpeurttochtActivated,
  notifySpeurttochtStart,
  notifyStepComplete,
  notifySpeurttochtComplete,
  notifySpeurttochtExpired,
  awardSpeurttochtPoints,
} from "./utils/notifications";

// Re-export commonly used constants for convenience
export { 
  STEP_TYPE_CONFIG,
  STEP_TYPE_ICONS, 
  STEP_TYPE_LABELS, 
  STEP_TYPE_COLORS,
  DEFAULT_POINTS_CONFIG,
  DEFAULT_NOTIFICATION_CONFIG,
} from "./types";

